angular.module('qkr').directive('messageValidate', messageValidate);
//FIXME this dicretive cannot be bound to the controller as it can be used in other places
//FIXME after update angular change to ng-messages
function messageValidate() {
    return {
        require: '^form',
        template: '<p class="msg-validation" ng-if="vm.isVisible()">' +
                    '{{vm.message()}}' +
                   '</p>',
        controller: 'RegistrationController',
        controllerAs: 'vm',
        bindToController: true,
        scope: {
            formFieldName: '&',
            message: '&'
        },
        link: (scope, elem, att, form) => {
            const field = form[scope.vm.formFieldName()];

            scope.vm.isVisible = () => {
                if (field) {
                    return (form.$submitted || field.$touched) &&
                        field.$error.required && field.$invalid;
                } else {
                    return false;
                }
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/directives/forms/message.validate.directive.js